import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Grade } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { GradeForm } from "../GradeForm";
import "./GradeItem.scss";

const gradeController = new Grade();

export function GradeItem(props) {
  const { grade, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateGrade = () => {
    setTitleModal(`Actualizar grado: ${grade.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar el grado ${grade.name}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await gradeController.deleteGrade(accessToken, grade.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="grade-item">
        <div className="grade-item__info">
          <span className="grade-item__info-name">{grade?.name || 'N/A'}</span>
        </div>
        <div className="grade-item__info">
          <span className="grade-item__info-level">{grade?.level?.name || 'N/A'}</span>
        </div>
        <div>
          <Popup
            content="Actualizar grado"
            trigger={
              <Button icon primary onClick={openUpdateGrade}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar grado"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <GradeForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          grade={grade}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
